<template>
  <!-- Label rendered by FiltersPanel's .fsb-label. -->
  <input
    type="text"
    class="fsb-range-input"
    :value="value"
    @change="(e) => $emit('input', e.target.value || null)"
  />
</template>

<script>
// Generic FreeText filter (e.g. SmartFilter).
export default {
  name: 'freeTextFilter',
  props: {
    filterKey: { type: String, required: true },
    value: { type: String, default: null },
  },
}
</script>

<style scoped>
.fsb-range-input {
  width: 100%;
  box-sizing: border-box;
  height: 30px;
  padding: 0 9px;
  border: 1.5px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12.5px;
  color: #374151;
  font-family: 'Inter', sans-serif;
  outline: none;
  background: #f9fafb;
  transition: border-color 0.15s;
}
.fsb-range-input:focus {
  border-color: #e05537;
  background: white;
}
</style>
